// src/pages/Tarifs/utils/pricingUtils.js

export function cn(...classes) {
  return classes.flat(Infinity).filter(Boolean).join(" ");
}

export function getInitials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
}

export function getApplicationsByCategory(applications, categoryId) {
  return applications.filter(
    (application) => application.category === categoryId,
  );
}